import component from './ShimmerSearchResults';

export default component;
